import React from 'react';
import styles from './styles.module.scss';
import { UseImageHovering } from './UseImageHovering';
import { ProductImageBase } from './ProductImageBase';

export const ProductImage = ({
  img,
  imgOnHover,
  frontImageAlt,
  backImageAlt,
}) => {
  const {
    onHover,
    onBlur,
    frontImageOnHover,
    backImageOnHover,
  } = UseImageHovering({
    frontImageOnHover: styles.frontImageOnHover,
    backImageOnHover: styles.backImageOnHover,
  });
  return (
    <div
      onMouseEnter={onHover}
      onMouseLeave={onBlur}
      className={styles.productImageContainer}>
      <ProductImageBase
        img={img}
        imgOnHover={imgOnHover}
        frontImageAlt={frontImageAlt}
        backImageAlt={backImageAlt}
        frontImageOnHover={frontImageOnHover}
        backImageOnHover={backImageOnHover}
      />
    </div>
  );
};
